// Shared dedupe for the shopping list and the stock view. (It used to be
// copy-pasted into both components - the duplication is how the shadowing
// bug stayed hidden.)
//
// Same-label items from different meals collapse into one list entry. The
// "winner" is the copy from the in-scope meal with the LOWEST position:
// extras is position 0, so its copy still shadows the meals', and a meal
// added this session (no server position yet) counts as the newest, so it
// can never shadow an established row. This matches a fresh page load
// exactly - the server returns meals in position order - so the list looks
// the same in-session as after a refresh.
//
// Invariant: fromMeal[0] is the winner's source, and the winner's row state
// (id / aisle / tick / stock) is what renders. The tick and aisle handlers
// send their server call to fromMeal[0] + the entry's id, so that has to stay.

function positionOf(position){
  // a missing position (meal added this session, or an old server) = newest
  return (typeof position === "number") ? position : Infinity
}

export function mergeIngredients(meals){
  let ingredientList = []
  meals.forEach((meal) => {
    if(!meal.inScope){
      return
    }
    meal.ingredients.forEach((ingredient) => {
      const source = {id : meal.id, label: meal.label, meal_ingredient_id: ingredient.id, position: meal.position}
      const existing = ingredientList.find((il) => il.label === ingredient.label)
      if (existing) {
        existing.copies.push({source, ingredient})
      } else {
        ingredientList.push({label: ingredient.label, copies: [{source, ingredient}]})
      }
    })
  })
  return ingredientList.map((item) => {
    const winner = item.copies.reduce((best, copy) =>
      positionOf(copy.source.position) < positionOf(best.source.position) ? copy : best)
    const fromMeal = item.copies.map((copy) => copy.source).sort((a, b) => {
      const pa = positionOf(a.position)
      const pb = positionOf(b.position)
      return pa < pb ? -1 : (pa > pb ? 1 : 0)
    })
    return {...winner.ingredient, fromMeal}
  })
}